export default function BuyPanel() {
    return (
        <div style={{height: '50px', gap: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div>Need more ducks?</div>
            <div>
                <a href="https://magiceden.io/marketplace/apexducks" target="magiceden">
                    <button className="clearButton">Browse&nbsp;here</button>
                </a>
            </div>
        </div>
    );
}
